import { render, staticRenderFns } from "./CollapseToggleButton.vue?vue&type=template&id=3ea5b7fd"
import script from "./CollapseToggleButton.vue?vue&type=script&lang=ts"
export * from "./CollapseToggleButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports